import { Badge as MUIBadge, BadgeProps as MUIBadgeProps } from '@mui/material';

export type BadgeProps = MUIBadgeProps;

export const Badge = MUIBadge;
